<template>
    <fieldset class="border border-blue-light bg-blue-lightest p-4 md:p-8 rounded">
        <legend class="font-bold text-blue text-center uppercase" v-if="legend">{{ legend }}</legend>
        <slot />
    </fieldset>
</template>

<script>
    export default {
        props: {
            legend: {
                required: false,
                type: String,
            }
        }
    };
</script>
